// @ts-strict-ignore
import React from 'react'
import { Typography, Grid } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import Condition from 'components/Condition'
import Button from 'components/Button'
import { conditionalClassList } from 'services/styles'
import { IUploadedVideo } from 'hooks/video'
import { useResponsiveBreakpoint } from 'hooks/useResponsiveBreakpoint'
import useStyles from './styles'

export interface ICompanyIntroductionProps {
  firm: {
    description?: string
  }
  video?: IUploadedVideo
  hideText?: boolean
  hideVideo?: boolean
}

function CompanyIntroduction(props: ICompanyIntroductionProps) {
  const { classes } = useStyles()
  const theme = useTheme()
  const { firm, hideText } = props

  const isMobile = useResponsiveBreakpoint(theme.breakpoints.values.md)
  const showText = !hideText
  const showVideo = false // TODO: this feature is unused, see below
  const shouldCollapseText = (isMobile && showText && firm.description.length >= 192)
  const [showFullText, setShowFullText] = React.useState(!shouldCollapseText)

  if (!showText && !showVideo) {
    return null
  }

  return (
    <div
      className={conditionalClassList({
        [classes.justified]: firm.description.length >= 192,
        [classes.centered]: firm.description.length < 192 && !showVideo,
      })}
    >
      <Typography variant="body1">
        {/* TODO: this feature is unused. Either let's remove it or start using it */}
        {/* {showVideo && ( */}
        {/*  <div className={conditionalClassList({ [classes.videoContainer]: true, [classes.videoOnly]: !showText })}> */}
        {/*    <Card raised className={classes.card}> */}
        {/*      <Video video={video} /> */}
        {/*    </Card> */}
        {/*  </div> */}
        {/* )} */}

        <Condition condition={showText}>
          <Condition condition={!showFullText}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {firm.description.substring(0, 190)}...
              </Grid>

              <Grid item xs={12}>
                <Button fullWidth onClick={() => setShowFullText(true)}>
                  Read More
                </Button>
              </Grid>
            </Grid>
          </Condition>

          <Condition condition={showFullText}>
            {firm.description}
          </Condition>
        </Condition>
      </Typography>
    </div>
  )
}

export default React.memo(CompanyIntroduction)
